/**
 * @generated SignedSource<<b1d99d2990b1af22938ca820b334a78b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type VideoPlayerEnum = "chorus" | "youtube" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SEOSchemasContainer_feedContentResource$data = {
  readonly __typename: string;
  readonly authors: ReadonlyArray<{
    readonly name: string;
    readonly permalink: string;
    readonly profileImage: {
      readonly thumbnails: {
        readonly square: {
          readonly url: string;
        };
      };
    } | null;
    readonly title: string;
  }>;
  readonly blocks: ReadonlyArray<{
    readonly __typename: "LegacyProductBlockType";
    readonly legacyProduct: {
      readonly brand: string;
      readonly image: {
        readonly thumbnails: {
          readonly horizontal: {
            readonly url: string;
          };
        };
      } | null;
      readonly retailLinks: ReadonlyArray<{
        readonly price: number;
        readonly retailer: string;
        readonly salePrice: number;
        readonly url: string;
      }>;
      readonly score: number;
      readonly title: string;
    };
  } | {
    readonly __typename: "LegacyProductsTableBlockType";
    readonly legacyProducts: ReadonlyArray<{
      readonly brand: string;
      readonly image: {
        readonly thumbnails: {
          readonly horizontal: {
            readonly url: string;
          };
        };
      } | null;
      readonly retailLinks: ReadonlyArray<{
        readonly price: number;
        readonly retailer: string;
        readonly salePrice: number;
        readonly url: string;
      }>;
      readonly score: number;
      readonly title: string;
    }>;
  } | {
    readonly __typename: "ProductBlockType";
    readonly product: {
      readonly brand: {
        readonly title: string;
      } | null;
      readonly image: {
        readonly thumbnails: {
          readonly horizontal: {
            readonly url: string;
          };
        };
      } | null;
      readonly retailLinks: ReadonlyArray<{
        readonly price: number;
        readonly retailer: string;
        readonly salePrice: number;
        readonly url: string;
      }>;
      readonly score: number;
      readonly showScores: boolean;
      readonly title: string;
    };
  } | {
    readonly __typename: "ProductsTableBlockType";
    readonly products: ReadonlyArray<{
      readonly brand: {
        readonly title: string;
      } | null;
      readonly image: {
        readonly thumbnails: {
          readonly horizontal: {
            readonly url: string;
          };
        };
      } | null;
      readonly retailLinks: ReadonlyArray<{
        readonly price: number;
        readonly retailer: string;
        readonly salePrice: number;
        readonly url: string;
      }>;
      readonly score: number;
      readonly showScores: boolean;
      readonly title: string;
    }>;
  } | {
    readonly __typename: "VideoBlockType";
    readonly autoplay: boolean;
    readonly caption: {
      readonly plaintext: string;
    };
    readonly video: {
      readonly player: VideoPlayerEnum;
      readonly poster: {
        readonly thumbnails: {
          readonly horizontal: {
            readonly url: string;
          };
        };
      } | null;
      readonly publishedAt: string | null;
      readonly title: string;
      readonly volumeUuid: string;
    } | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  }>;
  readonly categories: ReadonlyArray<{
    readonly parent: {
      readonly parent: {
        readonly permalink: string;
        readonly title: string;
      } | null;
      readonly permalink: string;
      readonly title: string;
    } | null;
    readonly permalink: string;
    readonly title: string;
  }>;
  readonly dek: {
    readonly plaintext: string;
  };
  readonly isPaywallEligible: boolean;
  readonly ledeMedia: {
    readonly __typename: "LedeMediaImageType";
    readonly image: {
      readonly originalHeight: number;
      readonly originalWidth: number;
      readonly thumbnails: {
        readonly horizontal: {
          readonly cropCoordinates: {
            readonly height: number;
            readonly width: number;
          };
          readonly url: string;
        };
        readonly social: {
          readonly cropCoordinates: {
            readonly height: number;
            readonly width: number;
          };
          readonly url: string;
        };
        readonly square: {
          readonly cropCoordinates: {
            readonly height: number;
            readonly width: number;
          };
          readonly url: string;
        };
      };
    };
  } | {
    readonly __typename: "LedeMediaVideoType";
    readonly autoplay: boolean;
    readonly caption: {
      readonly plaintext: string;
    };
    readonly video: {
      readonly player: VideoPlayerEnum;
      readonly poster: {
        readonly thumbnails: {
          readonly horizontal: {
            readonly url: string;
          };
        };
      } | null;
      readonly publishedAt: string | null;
      readonly title: string;
      readonly volumeUuid: string;
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly liveStatus: {
    readonly endAt: string | null;
    readonly startAt: string | null;
    readonly status: boolean;
  };
  readonly originalPublishedAt: string | null;
  readonly permalink: string;
  readonly primaryCampaign: {
    readonly id: string;
  } | null;
  readonly primaryCategory: {
    readonly parent: {
      readonly parent: {
        readonly permalink: string;
        readonly title: string;
      } | null;
      readonly permalink: string;
      readonly title: string;
    } | null;
    readonly permalink: string;
    readonly title: string;
  };
  readonly publishedAt: string | null;
  readonly quickAttachment?: {
    readonly __typename: "ProductBlockType";
    readonly product: {
      readonly brand: {
        readonly title: string;
      } | null;
      readonly image: {
        readonly thumbnails: {
          readonly horizontal: {
            readonly url: string;
          };
        };
      } | null;
      readonly retailLinks: ReadonlyArray<{
        readonly price: number;
        readonly retailer: string;
        readonly salePrice: number;
        readonly url: string;
      }>;
      readonly score: number;
      readonly showScores: boolean;
      readonly title: string;
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly seo: {
    readonly description: string;
    readonly headline: string;
  };
  readonly seoArticleBody: string;
  readonly streamPosts?: {
    readonly nodes: ReadonlyArray<{
      readonly authors: ReadonlyArray<{
        readonly name: string;
        readonly permalink: string;
        readonly profileImage: {
          readonly thumbnails: {
            readonly square: {
              readonly url: string;
            };
          };
        } | null;
        readonly title: string;
      }>;
      readonly categories: ReadonlyArray<{
        readonly parent: {
          readonly parent: {
            readonly permalink: string;
            readonly title: string;
          } | null;
          readonly permalink: string;
          readonly title: string;
        } | null;
        readonly permalink: string;
        readonly title: string;
      }>;
      readonly dek: {
        readonly plaintext: string;
      };
      readonly excerpt?: ReadonlyArray<{
        readonly paragraphContents: ReadonlyArray<{
          readonly plaintext: string;
        }>;
      }>;
      readonly isPaywallEligible: boolean;
      readonly ledeMedia: {
        readonly __typename: "LedeMediaImageType";
        readonly image: {
          readonly originalHeight: number;
          readonly originalWidth: number;
          readonly thumbnails: {
            readonly horizontal: {
              readonly cropCoordinates: {
                readonly height: number;
                readonly width: number;
              };
              readonly url: string;
            };
            readonly social: {
              readonly cropCoordinates: {
                readonly height: number;
                readonly width: number;
              };
              readonly url: string;
            };
            readonly square: {
              readonly cropCoordinates: {
                readonly height: number;
                readonly width: number;
              };
              readonly url: string;
            };
          };
        };
      } | {
        readonly __typename: "LedeMediaVideoType";
        readonly autoplay: boolean;
        readonly caption: {
          readonly plaintext: string;
        };
        readonly video: {
          readonly player: VideoPlayerEnum;
          readonly poster: {
            readonly thumbnails: {
              readonly horizontal: {
                readonly url: string;
              };
            };
          } | null;
          readonly publishedAt: string | null;
          readonly title: string;
          readonly volumeUuid: string;
        };
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null;
      readonly originalPublishedAt: string | null;
      readonly permalink: string;
      readonly primaryCategory: {
        readonly title: string;
      };
      readonly publishedAt: string | null;
      readonly quickAttachment?: {
        readonly __typename: "ProductBlockType";
        readonly product: {
          readonly brand: {
            readonly title: string;
          } | null;
          readonly image: {
            readonly thumbnails: {
              readonly horizontal: {
                readonly url: string;
              };
            };
          } | null;
          readonly retailLinks: ReadonlyArray<{
            readonly price: number;
            readonly retailer: string;
            readonly salePrice: number;
            readonly url: string;
          }>;
          readonly score: number;
          readonly showScores: boolean;
          readonly title: string;
        };
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null;
      readonly seo: {
        readonly description: string;
        readonly headline: string;
      };
      readonly title: string;
    }>;
  } | null;
  readonly streamPublishedAt?: string | null;
  readonly title: string;
  readonly " $fragmentType": "SEOSchemasContainer_feedContentResource";
};
export type SEOSchemasContainer_feedContentResource$key = {
  readonly " $data"?: SEOSchemasContainer_feedContentResource$data;
  readonly " $fragmentSpreads": FragmentRefs<"SEOSchemasContainer_feedContentResource">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ShareableDataType",
  "kind": "LinkedField",
  "name": "seo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "plaintext",
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "RichTextType",
  "kind": "LinkedField",
  "name": "dek",
  "plural": false,
  "selections": (v3/*:: as any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalPublishedAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permalink",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPaywallEligible",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v10 = [
  (v9/*:: as any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "AuthorProfileResourceType",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    (v7/*:: as any*/),
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageResourceType",
      "kind": "LinkedField",
      "name": "profileImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ThumbnailMapType",
          "kind": "LinkedField",
          "name": "thumbnails",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ThumbnailType",
              "kind": "LinkedField",
              "name": "square",
              "plural": false,
              "selections": (v10/*:: as any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = [
  (v1/*:: as any*/),
  (v7/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CategoryResourceType",
    "kind": "LinkedField",
    "name": "parent",
    "plural": false,
    "selections": [
      (v1/*:: as any*/),
      (v7/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "CategoryResourceType",
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          (v7/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "CategoryResourceType",
  "kind": "LinkedField",
  "name": "categories",
  "plural": true,
  "selections": (v12/*:: as any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "score",
  "storageKey": null
},
v15 = [
  (v1/*:: as any*/)
],
v16 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "price",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "retailer",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "salePrice",
    "storageKey": null
  },
  (v9/*:: as any*/)
],
v17 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ThumbnailMapType",
    "kind": "LinkedField",
    "name": "thumbnails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ThumbnailType",
        "kind": "LinkedField",
        "name": "horizontal",
        "plural": false,
        "selections": (v10/*:: as any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "ImageResourceType",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v17/*:: as any*/),
  "storageKey": null
},
v19 = [
  (v1/*:: as any*/),
  (v14/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "showScores",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ProductBrandResourceType",
    "kind": "LinkedField",
    "name": "brand",
    "plural": false,
    "selections": (v15/*:: as any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ProductRetailLinkType",
    "kind": "LinkedField",
    "name": "retailLinks",
    "plural": true,
    "selections": (v16/*:: as any*/),
    "storageKey": null
  },
  (v18/*:: as any*/)
],
v20 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductBlockProductType",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": (v19/*:: as any*/),
      "storageKey": null
    }
  ],
  "type": "ProductBlockType",
  "abstractKey": null
},
v21 = [
  (v1/*:: as any*/),
  (v14/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "brand",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "LegacyProductBlockRetailLinkType",
    "kind": "LinkedField",
    "name": "retailLinks",
    "plural": true,
    "selections": (v16/*:: as any*/),
    "storageKey": null
  },
  (v18/*:: as any*/)
],
v22 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "autoplay",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "RichTextType",
    "kind": "LinkedField",
    "name": "caption",
    "plural": false,
    "selections": (v3/*:: as any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "VolumeVideoResourceType",
    "kind": "LinkedField",
    "name": "video",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "volumeUuid",
        "storageKey": null
      },
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "player",
        "storageKey": null
      },
      (v6/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ImageResourceType",
        "kind": "LinkedField",
        "name": "poster",
        "plural": false,
        "selections": (v17/*:: as any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v23 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "quickAttachment",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        (v20/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "QuickPostResourceType",
  "abstractKey": null
},
v24 = [
  (v9/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CoordinatesType",
    "kind": "LinkedField",
    "name": "cropCoordinates",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v25 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "ledeMedia",
  "plural": false,
  "selections": [
    (v0/*:: as any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageResourceType",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "originalWidth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "originalHeight",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ThumbnailMapType",
              "kind": "LinkedField",
              "name": "thumbnails",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ThumbnailType",
                  "kind": "LinkedField",
                  "name": "social",
                  "plural": false,
                  "selections": (v24/*:: as any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ThumbnailType",
                  "kind": "LinkedField",
                  "name": "horizontal",
                  "plural": false,
                  "selections": (v24/*:: as any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ThumbnailType",
                  "kind": "LinkedField",
                  "name": "square",
                  "plural": false,
                  "selections": (v24/*:: as any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "LedeMediaImageType",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v22/*:: as any*/),
      "type": "LedeMediaVideoType",
      "abstractKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SEOSchemasContainer_feedContentResource",
  "selections": [
    (v0/*:: as any*/),
    (v1/*:: as any*/),
    (v2/*:: as any*/),
    (v4/*:: as any*/),
    (v5/*:: as any*/),
    (v6/*:: as any*/),
    (v7/*:: as any*/),
    (v8/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "LiveStatusType",
      "kind": "LinkedField",
      "name": "liveStatus",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v11/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "seoArticleBody",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CampaignResourceType",
      "kind": "LinkedField",
      "name": "primaryCampaign",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CategoryResourceType",
      "kind": "LinkedField",
      "name": "primaryCategory",
      "plural": false,
      "selections": (v12/*:: as any*/),
      "storageKey": null
    },
    (v13/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "blocks",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        (v20/*:: as any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LegacyProductBlockProductType",
              "kind": "LinkedField",
              "name": "legacyProduct",
              "plural": false,
              "selections": (v21/*:: as any*/),
              "storageKey": null
            }
          ],
          "type": "LegacyProductBlockType",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductBlockProductType",
              "kind": "LinkedField",
              "name": "products",
              "plural": true,
              "selections": (v19/*:: as any*/),
              "storageKey": null
            }
          ],
          "type": "ProductsTableBlockType",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LegacyProductBlockProductType",
              "kind": "LinkedField",
              "name": "legacyProducts",
              "plural": true,
              "selections": (v21/*:: as any*/),
              "storageKey": null
            }
          ],
          "type": "LegacyProductsTableBlockType",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v22/*:: as any*/),
          "type": "VideoBlockType",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "streamPublishedAt",
          "storageKey": null
        },
        {
          "alias": "streamPosts",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 100
            }
          ],
          "concreteType": "ArchiveFeedContentConnection",
          "kind": "LinkedField",
          "name": "posts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v1/*:: as any*/),
                (v2/*:: as any*/),
                (v4/*:: as any*/),
                (v5/*:: as any*/),
                (v6/*:: as any*/),
                (v7/*:: as any*/),
                (v8/*:: as any*/),
                (v11/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CategoryResourceType",
                  "kind": "LinkedField",
                  "name": "primaryCategory",
                  "plural": false,
                  "selections": (v15/*:: as any*/),
                  "storageKey": null
                },
                (v13/*:: as any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CoreParagraphBlockType",
                      "kind": "LinkedField",
                      "name": "excerpt",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RichTextType",
                          "kind": "LinkedField",
                          "name": "paragraphContents",
                          "plural": true,
                          "selections": (v3/*:: as any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "PostResourceType",
                  "abstractKey": null
                },
                (v23/*:: as any*/),
                (v25/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": "posts(first:100)"
        }
      ],
      "type": "StreamResourceType",
      "abstractKey": null
    },
    (v25/*:: as any*/),
    (v23/*:: as any*/)
  ],
  "type": "FeedContentResourceInterface",
  "abstractKey": "__isFeedContentResourceInterface"
};
})();

(node as any).hash = "beaf5bf59bb4858eec87bb95220c7fb6";

export default node;
